import React, { useState } from "react";
import PropTypes from "prop-types";

import { Alert, Button, Checkbox, Flex, Form, Input } from "antd";
import { Card, FormItem } from "../components";

import {
  LEGALE_FRONTEND_BASE_URL,
  lsKeyToken,
  msgFieldInvalid,
  msgFieldRequired,
} from "../utils/constants";
import { parseErrorHelper } from "../utils/helpers";
import { loginRequest } from "../services/apis/auth";

import LegaleLogo from "../assets/images/logo.png";

import "../assets/styles/views/login.scss";

const props = {
  onLogin: PropTypes.func.isRequired,
};

const LoginView = ({ onLogin }) => {
  const [form] = Form.useForm();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const submitHandler = (values) => {
    console.log(values);
    setLoading(true);
    setError(null);
    loginRequest(values)
      .then((res) => {
        setLoading(false);
        const { token } = res.data;
        if (token) {
          onLogin(token);
          localStorage.setItem(lsKeyToken, token);
        }
      })
      .catch((e) => {
        setLoading(false);
        setError(parseErrorHelper(e));
      });
  };

  return (
    <Flex vertical justify="center" align="center" className="login-view">
      <Card className="login-card">
        <Flex justify="center" className="mb-3">
          <img className="logo-img" src={LegaleLogo} alt="Legale" />
        </Flex>

        {Boolean(error) && (
          <Alert
            message={error}
            type="error"
            className="mb-3"
            closable
            onClose={() => setError(null)}
          />
        )}

        <Form layout="vertical" form={form} onFinish={submitHandler}>
          <FormItem
            label="Email"
            name="email"
            rules={[
              { required: true, message: msgFieldRequired },
              { type: "email", message: msgFieldInvalid },
            ]}
          >
            <Input placeholder="example@legale.io" />
          </FormItem>
          <FormItem
            label="Password"
            name="password"
            rules={[{ required: true, message: msgFieldRequired }]}
          >
            <Input.Password />
          </FormItem>
          <Flex className="mt-3 mb-3" justify="space-between" align="center">
            <Checkbox>Remember me</Checkbox>
            <a href={`${LEGALE_FRONTEND_BASE_URL}/password`} target="_blank">
              Forgot password?
            </a>
          </Flex>
          <Button htmlType="submit" type="primary" block loading={loading}>
            Submit
          </Button>
        </Form>
      </Card>
    </Flex>
  );
};

LoginView.propTypes = props;

export default LoginView;
